
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artikler",
      function () {
        return require("private-next-pages/artikler/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artikler"])
      });
    }
  